<div class="appointment-container">
  <app-navbar></app-navbar>
  <div class="main-content">
    <div class="content-wrapper">
      <div class="schedule-appointment">
        <h1 class="title">Schedule a Telehealth Appointment</h1>
        <p class="subtitle">
          For in-person visits, please call us at
          <app-phone-number (clicked)="onPhoneNumberClicked()"></app-phone-number> or
          <app-clickable-link linkText="Click here." linkType="custom" customEventName="ols_in_person_click_here" (clicked)="onClickHereClicked()"></app-clickable-link><br>
          For telehealth appointments, fill out the form below to continue scheduling.
        </p>
      </div>
      <!-- <div class="insurance-medicare">
        <span class="note-ico"><img src="/alert1.png" alt="Alert" class="alert-icon" /> </span>
        <div class="note-text">
          If you have <span class="medicare">Medicare</span> insurance, please contact our team before scheduling your telehealth appointment.
          <span class="some-medicare ">Some Medicare plans require an in-person visit</span> before proceeding with a telehealth visit, while others do not.
           Call us at <a href="tel:919-391-7202" class="number"><span class="number">919-391-7202</span></a>
        </div>
      </div> -->
        <div class="form-card">
        <div class="step-indicator">
          <div class="step active">
            <div class="step-number">1</div>
          </div>
          <div class="step-line"></div>
          <div class="step">
            <div class="step-number">2</div>
          </div>
        </div>
        <div class="question-section">
          <div class="question">Are you a new or returning patient?</div>
          <div class="radio-group">
            <div class="radio-option">
              <input
                type="radio"
                id="newPatient"
                name="patientType"
                value="new"
                (change)="onPatientTypeSelect('new')"
              />
              <label for="newPatient">New Patient</label>
            </div>
            <div class="radio-option">
              <input
                type="radio"
                id="returningPatient"
                name="patientType"
                value="returning"
                (change)="onPatientTypeSelect('returning')"
              />
              <label for="returningPatient">Returning Patient</label>
            </div>
          </div>
          <div class="form-error" *ngIf="errorMessage">{{ errorMessage }}</div>
          <div class="form-actions" style="margin-top: 16px;">
            <button type="button" class="submit-btn" (click)="onNext()">Next</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
  
  <app-in-person-modal 
    [isVisible]="showInPersonModal" 
    (closed)="closeInPersonModal()" 
    (submitted)="closeInPersonModal()">
  </app-in-person-modal>
  <app-returning-patient 
    [isVisible]="showReturningPatientModal"
    (modalClosed)="onModalClosed()">
  </app-returning-patient>
</div>
